import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eterniza_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const brl = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const productImage = (p) => p?.image_url || "";

export const uploadUrl = (fileId) => (fileId ? `${API_BASE}/uploads/${fileId}` : "");
